module.exports = __webpack_public_path__ + "static/media/rMom.727cee03.png";